<mat-label class="subHeading">Policy Age</mat-label>
<input formControlNam="policy_age" class="policy"/>